module.exports = __webpack_public_path__ + "static/media/master-shot-2.cb3e3d84.webp";